import React from 'react'

function RequestSkilledWorkers() {
  return (
    <div>RequestSkilledWorkers</div>
  )
}

export default RequestSkilledWorkers